import { load3DLogo } from '../../vendor/index.js';

export default {
	init() {
		// $('.popup_consultation').css('height', $(window).height() + 'px');
		$('.module-consultation .gform_page:first-child .gfield_radio .gchoice:last-child input').on('change', function () {
			$('.gform_body').animate({ scrollTop: $('.gform_body').height() }, 200)
		  });
		$(
			'.module-consultation .gform-body .gform_page_fields .image-choices-choice-image-wrap img'
		).each(function () {
			const import_url_image = $(this).attr('data-lightbox-src');
			$(this)
				.parent()
				.css('mask-image', 'url(' + import_url_image + ')');
			$(this)
				.parent()
				.css('-webkit-mask-image', 'url(' + import_url_image + ')');
			$(this)
				.parent()
				.css('background-image', 'none');
		});

		$(
			'.popup_consultation .gform_body .gform_page_fields .gform_fields .gfield_visibility_visible.url .ginput_container_text'
		).each(function () {
			$(this).append('<span class="focus-border"></span>');
		});

		$(
			'.popup_consultation .gform_body  .gform_page_fields .gform_fields .gfield_visibility_visible label.gfield_label'
		).each(function () {
			$(this).next().append($(this));
		});

		$(
			'.popup_consultation .gform_body  .gform_page_fields .gform_fields .gfield_visibility_visible .ginput_container_text input, .popup_consultation .other input'
		).each(function () {
			$(this).focusout(function () {
				if ($(this).val() != '') {
					$(this).addClass('has-content');
				} else {
					$(this).removeClass('has-content');
					$(this).val('');
				}
			});
		});

		let scene3D;

		MutationObserver =
			window.MutationObserver || window.WebKitMutationObserver;

		var observer = new MutationObserver(function (mutations, observer) {
			$(
				'.module-consultation .gform-body .gform_page_fields .image-choices-choice-image-wrap img'
			).each(function () {
				const import_url_image = $(this).attr('src');
				$(this)
					.parent()
					.css('mask-image', 'url(' + import_url_image + ')');
				$(this)
					.parent()
					.css('-webkit-mask-image', 'url(' + import_url_image + ')');
			});
		});

		observer.observe(
			document.getElementsByClassName('popup_consultation')[0],
			{
				subtree: true,
				attributes: true,
			}
		);

		function openPopup() {
			const logoContainer = $('.wrap_popup .logo_3d_consultation');
			if (logoContainer.find('canvas').length == 0) { 
    			load3DLogo({ container: logoContainer[0], dark: true }).then(
    				(scene) => {
    					scene3D = scene;
    					scene3D.play();
    				}
    			);
			}
			

			$('.popup_consultation').addClass('open');
			$('html').addClass('popup');
			$('.module-consultation').css({ pointerEvents: 'auto' });
			if (
				$(
					'.module-consultation .popup_consultation .popup_content'
				).find('.gform_confirmation_wrapper').length !== 0
			) {
				$(
					'.module-consultation .popup_consultation .wrap_popup .logo_3d'
				).css('display', 'block');
			}
		}

		$('.btn[data-popup="consultation"]').on('click', openPopup);

		$('.popup_consultation .close').on('click', function () {
			$('.popup_consultation').removeClass('open');
			$('html').removeClass('popup');
			$('.module-consultation').css({ pointerEvents: 'none' });

			if (scene3D) {
				scene3D.pause();
			}
		});

		$('.popup_consultation .gfield_radio .gchoice:last-child input').on(
			'change',
			function (e) {
				$(this)
					.parents('.form_conception')
					.animate({ scrollTop: $(document).height() }, 1000);
			}
		);

		jQuery(document).on(
			'gform_page_loaded',
			function (event, form_id, current_page) {
				$(
					'.module-consultation .gform-body .gform_page_fields .image-choices-choice-image-wrap img'
				).each(function () {
					const import_url_image = $(this).attr('data-lightbox-src');
					$(this)
						.parent()
						.css('mask-image', 'url(' + import_url_image + ')');
					$(this)
						.parent()
						.css('-webkit-mask-image', 'url(' + import_url_image + ')');
					$(this)
						.parent()
						.css('background-image', 'none');
				});

				$(
					'.popup_consultation .gfield_radio .gchoice:last-child input'
				).on('change', function (e) {
					$(this)
						.parents('.form_conception')
						.animate({ scrollTop: $(document).height() }, 1000);
				});

				$(
					'.popup_consultation .gform_body .gform_page_fields .gform_fields .gfield_visibility_visible .ginput_container_text, .popup_consultation .gform_body .form_loading_pages_popup .gform_page_fields .gform_fields .gfield_visibility_visible .ginput_container_phone, .popup_consultation .gform_body .form_loading_pages_popup .gform_page_fields .gform_fields .gfield_visibility_visible .ginput_container_website, .popup_consultation .gform_body .form_loading_pages_popup .gform_page_fields .gform_fields .gfield_visibility_visible .ginput_container_email, .popup_consultation .gform_body .form_loading_pages_popup .gform_page_fields .gform_fields .gfield_visibility_visible .ginput_container .name_first, .popup_consultation .gform_body .form_loading_pages_popup .gform_page_fields .gform_fields .gfield_visibility_visible .ginput_container .name_last'
				).each(function () {
					$(this).append('<span class="focus-border"></span>');
				});

				$(
					'.popup_consultation .gform_body  .gform_page_fields .gform_fields .gfield_visibility_visible .ginput_container_text input, .popup_consultation .gform_body .form_loading_pages_popup .gform_page_fields .gform_fields .gfield_visibility_visible .ginput_container_textarea textarea, .popup_consultation .gform_body .gform_page_fields .gform_fields .gfield_visibility_visible .ginput_container_textarea textarea, .popup_consultation .gform_body .form_loading_pages_popup .gform_page_fields .gform_fields .gfield_visibility_visible .ginput_container_phone input, .popup_consultation .gform_body .form_loading_pages_popup .gform_page_fields .gform_fields .gfield_visibility_visible .ginput_container_website input, .popup_consultation .gform_body .form_loading_pages_popup .gform_page_fields .gform_fields .gfield_visibility_visible .ginput_container_email input, .popup_consultation .gform_body .form_loading_pages_popup .gform_page_fields .gform_fields .gfield_visibility_visible .ginput_container .name_first input, .popup_consultation .gform_body .form_loading_pages_popup .gform_page_fields .gform_fields .gfield_visibility_visible .ginput_container .name_last input, .popup_consultation .gform_body .other input'
				).each(function () {
					if ($(this).val() != '') {
						$(this).addClass('has-content');
					} else {
						$(this).removeClass('has-content');
						$(this).val('');
					}

					$(this).focusout(function () {
						if ($(this).val() != '') {
							$(this).addClass('has-content');
						} else {
							$(this).removeClass('has-content');
							$(this).val('');
						}
					});
				});

				$(
					'.popup_consultation .gform_body  .gform_page_fields .gform_fields .gfield_visibility_visible label.gfield_label'
				).each(function () {
					$(this).next().append($(this));
				});

				$(
					'.popup_consultation .gform_body  .gform_page_fields .gform_fields .textarea_project.gfield_visibility_visible .ginput_container_textarea'
				).append(function () {
					var label_inside = $(
						'.popup_consultation .gform_body  .gform_page_fields .gform_fields .textarea_project.gfield_visibility_visible label.gfield_label'
					);
					return label_inside;
				});
			}
		);
	},
};
